import React, { useEffect, useState } from "react";
import { HashLink as Link } from "react-router-hash-link";

const AboutV1 = () => {
  const [aboutData, setAboutData] = useState(null);

  useEffect(() => {
    const fetchAboutData = async () => {
      try {
        const response = await fetch("https://eventscons.com/eventbackendnew/api/aboutus-details");
        const result = await response.json();

        if (result?.status && result?.data) {
          setAboutData(result.data);
        }
      } catch (error) {
        console.error("About Us API fetch error:", error);
      }
    };

    fetchAboutData();
  }, []);

  const renderStyledTitle = (title) => {
    if (!title) return "";

    const words = title.trim().split(" ");

    if (words.length <= 3) {
      return <span style={{ color: "#b21e35" }}>{title}</span>;
    }

    const normalText = words.slice(0, -3).join(" ");
    const coloredText = words.slice(-3).join(" ");

    return (
      <>
        {normalText} <span style={{ color: "#b21e35" }}>{coloredText}</span>
      </>
    );
  };

  if (!aboutData) {
    return (
      <section className="about-section" style={{ paddingTop: "80px", }}>
        <div className="auto-container">
          <p>Loading...</p>
        </div>
      </section>
    );
  }

  return (
    <section className="about-section" style={{ paddingTop: "80px",paddingBottom:"0px", overflow: "hidden" }}>
      <div className="auto-container">
        <div className="row align-items-center">
          <div className="content-column col-lg-6 col-md-12 col-sm-12">
            <div className="inner-column" style={{ paddingRight: "30px" }}>
              <div className="sec-title">
                <h2 className="mainheadingfont" 
                  style={{
                    fontSize: "35px",
                    fontWeight: "500",
                    lineHeight: "1.2",
                    color: "#000",
                    textAlign: "left",
                  }}
                >
                  {renderStyledTitle(aboutData?.about_title)}
                </h2>

                <div
                  className="text mainparafont"
                  style={{
                    fontSize: "16px",
                    marginTop: "20px",
                    color: "#666",
                    lineHeight: "1.6",
                  }}
                >
                  {aboutData?.about_text}
                </div>
              </div>

              <div
                className="btn-box"
                style={{ display: "flex", gap: "15px", marginTop: "30px" }}
              >
                <a
                  href={aboutData?.about_button_link}
                  className="theme-btn btn-style-three"
                  style={{
                    background: "#000",
                    color: "#fff",
                    padding: "12px 35px",
                    textDecoration: "none",
                    borderRadius: "0px",
                    display: "inline-block",
                  }}
                >
                  <span className="btn-title">{aboutData?.about_button_text}</span>
                </a>
              </div>
            </div>
          </div>

          <div className="image-column col-lg-6 col-md-12 col-sm-12">
            <div
              className="image-box"
              style={{
                position: "relative",
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
              }}
            >
              <img
                src={aboutData?.about_image}
                alt={aboutData?.about_title || "About Us"}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutV1;